import React from "react";
import "../Menu.css"; // Ensure your custom styles are applied here
import Footer from "./footer";
import Homecarousel from "./homecarousel";
import Navbar from "./navbar";

const KeyObjectives = () => {
	return (
		<div>
			<Navbar />
			<div>
				<Homecarousel />
			</div>

			<div className="ko-main-container">
				<div style={{ marginTop: "50px", marginBottom: "100px" }}>
					<div>
						<div className="e-con-inner">
							<div className="top-section">
								<div className="ko-text">
									<h2 className="elementor-heading-title">Key Objectives</h2>
									<ul
										style={{
											display: "flex",
											flexDirection: "column",
											gap: "10px",
											padding: "20px",
										}}>
										<li style={{ margin: "0px" }}>
											<div className="rc-list">
												<div className="rc-icon">
													<svg
														aria-hidden="true"
														className="e-font-icon-svg e-fas-leaf"
														viewBox="0 0 576 512"
														xmlns="http://www.w3.org/2000/svg">
														<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
													</svg>
												</div>
												<span className="koul-text">
													Empower a skilled workforce — Equip farmers and
													processors to meet global standards.
												</span>
											</div>
										</li>
										<li style={{ margin: "0px" }}>
											<div className="rc-list">
												<div className="rc-icon">
													<svg
														aria-hidden="true"
														className="e-font-icon-svg e-fas-leaf"
														viewBox="0 0 576 512"
														xmlns="http://www.w3.org/2000/svg">
														<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
													</svg>
												</div>
												<span className="koul-text">
													Drive higher incomes — Unlock premium market access
													for certified produce.
												</span>
											</div>
										</li>
										<li style={{ margin: "0px" }}>
											<div className="rc-list">
												<div className="rc-icon">
													<svg
														aria-hidden="true"
														className="e-font-icon-svg e-fas-leaf"
														viewBox="0 0 576 512"
														xmlns="http://www.w3.org/2000/svg">
														<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
													</svg>
												</div>
												<span className="koul-text">
													Champion safe, sustainable food — Build trust through
													quality and compliance.
												</span>
											</div>
										</li>
										<li style={{ margin: "0px" }}>
											<div className="rc-list">
												<div className="rc-icon">
													<svg
														aria-hidden="true"
														className="e-font-icon-svg e-fas-leaf"
														viewBox="0 0 576 512"
														xmlns="http://www.w3.org/2000/svg">
														<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
													</svg>
												</div>
												<span className="koul-text">
													Enhance climate resilience — Enable carbon credits and
													sustainable growth.
												</span>
											</div>
										</li>
										<li style={{ margin: "0px" }}>
											<div className="rc-list">
												<div className="rc-icon">
													<svg
														aria-hidden="true"
														className="e-font-icon-svg e-fas-leaf"
														viewBox="0 0 576 512"
														xmlns="http://www.w3.org/2000/svg">
														<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
													</svg>
												</div>
												<span className="koul-text">
													Strengthen global food security — Position India as a
													leader in safe, sustainable food.
												</span>
											</div>
										</li>
									</ul>
								</div>
							</div>

							{/* Right Section: Vision and Mission */}
							<div className="bottom-section">
								{/* Vision */}
								<div className="vision">
									<div className="icon">
										<i aria-hidden="true" className="fa fa-eye"></i>
									</div>
									<div className="text">
										<h3>Vision</h3>
										<p>
											To establish India as a global leader in safe,
											sustainable, and certified food systems.
										</p>
									</div>
								</div>

								{/* Mission */}
								<div className="mission">
									<div className="icon">
										<i aria-hidden="true" className="fas fa-atom"></i>
									</div>
									<div className="text">
										<h3>Mission</h3>
										<p>
											To scale a global AI-powered platform delivering
											expert-led training, model farm demonstrations, and
											digital compliance tools—enabling rapid, scalable adoption
											of food safety and sustainability standards across the
											agri-food ecosystem.
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</div>
	);
};

export default KeyObjectives;
